var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CtrlSearchCommonComponents',_vm._b({attrs:{"dialogProps":{
    width: '1000px',
  },"tableProps":{
    headers: _vm.headers,
    formatColName: _vm.formatColName,
  },"apiParams":{
    haisoKaishaCd: _vm.haisoKaishaCd,
    mukoUmuFlg: _vm.mukoUmuFlg,
  }}},'CtrlSearchCommonComponents',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }